import React, { useState } from 'react';

const VariationList = ({ variations = [], type = 'price', productId }) => {
    const [expanded, setExpanded] = useState(false);

    const visibleVariations = expanded ? variations : variations.slice(0, 2);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {visibleVariations.map((v, idx) => (
                <span key={idx}>
                    <strong>
                        {Object.entries(v.attributes || {}).map(([k, val]) => `${k}: ${val}`).join(', ')}
                    </strong>
                    <br />
                    ₹ {type === 'sale' ? (v.salePrice || v.price) : v.price}
                </span>
            ))}

            {variations.length > 3 && (
                <span
                    style={{ color: '#007bff', cursor: 'pointer', fontSize: '13px' }}
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? 'Show less' : 'Show more'}
                </span>
            )}
        </div>
    );
};

export default VariationList;
